import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = ({ type, data }) => {
  const getStructuredData = () => {
    switch (type) {
             case 'organization':
         return {
           "@context": "https://schema.org",
           "@type": "Organization",
           "name": "VR Media Network",
           "url": "https://vr-media.in/",
           "logo": "https://vr-media.in/logo.png",
           "description": "VR Media Network manages YouTube channels delivering engaging content in cinema, travel, lifestyle, and entertainment.",
           "address": {
             "@type": "PostalAddress",
             "addressCountry": "IN"
           },
           "sameAs": [
             "https://www.youtube.com/@VRMediaNetwork.Official",
             "https://www.youtube.com/@vrreligious",
             "https://www.youtube.com/@vrkitchenchannel",
             "https://www.youtube.com/@vrshortstories",
             "https://www.youtube.com/@vrwellnesschannel"
           ]
         };
      
             case 'website':
         return {
           "@context": "https://schema.org",
           "@type": "WebSite",
           "name": "VR Media Network",
           "url": "https://vr-media.in",
           "description": "VR Media Network manages YouTube channels delivering engaging content in cinema, travel, lifestyle, and entertainment.",
           "publisher": {
             "@type": "Organization",
             "name": "VR Media Network",
             "logo": {
               "@type": "ImageObject",
               "url": "https://vr-media.in/logo.png"
             }
           },
           "potentialAction": {
             "@type": "SearchAction",
             "target": "https://vr-media.in/search?q={search_term_string}",
             "query-input": "required name=search_term_string"
           }
         };
      
      case 'videoObject':
        return {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": data.title,
          "description": data.description,
          "thumbnailUrl": data.thumbnail,
          "uploadDate": data.publishedAt,
          "duration": data.duration,
          "contentUrl": data.videoUrl,
          "embedUrl": data.embedUrl,
                     "publisher": {
             "@type": "Organization",
             "name": "VR Media Network",
             "logo": {
               "@type": "ImageObject",
               "url": "https://vr-media.in/logo.png"
             }
           }
        };
      
      case 'breadcrumbList':
        return {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": data.items.map((item, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "name": item.name,
            "item": item.url
          }))
        };
      
      default:
        return data;
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(getStructuredData())}
      </script>
    </Helmet>
  );
};

export default StructuredData;
